<template>
  <v-app>
    <v-content>
      <searchCondition />
      <OrderList />
    </v-content>
  </v-app>
</template>

<script>
// @ is an alias to /src
import OrderList from '@/components/orderList.vue'
// import searchCondition from '@/components/searchCondition.vue'

export default {
  name: 'factory',
  data: () => {
    return {
      PAGE_NAME: '注文状況一覧画面'
    }
  },
  created: function () {
    window.addEventListener('beforeunload', this.handler)
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.handler)
  },
  mounted: function () {
    if (!this.$store.state.isLogin) {
      this.$router.push({ path: '/' })
    }
    this.$store.commit('setPageName', { name: this.PAGE_NAME })
  },
  components: {
    OrderList
    // searchCondition
  },
  methods: {
    handler (event) {
      event.returnValue = "Data you've inputted won't be synced"
    }
  }
}
</script>
